
  import { defineComponent } from 'vue';
  import LogoAnchor from '@/ui/components/analytics/LogoAnchor.vue';

  export default defineComponent({
    components: { LogoAnchor },
  });
